module.exports = __webpack_public_path__ + "static/img/메달-문화예술.2aead7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/메달-문화예술.png
// module id = NgX5
// module chunks = 0